<template>
  <div>
      <div class="dataFrom">
                <van-cell-group>
                    <van-field v-model="takePhone" label="手机号" placeholder="请输入领卡时的手机号" />
                </van-cell-group>
            <mt-button type="primary" size="large" @click="getQuestionList">搜索</mt-button> 
      </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-cell v-for="(item, index) in buyCardList" :key="index" >
        <p>号码：{{ recordLoginText }}</p>
        <p>姓名：{{ item.takeNickname }}</p>
        <p>创建时间：{{ item.createTime }}</p>
        <p>新iccid：{{ item.newIccid }}</p>
        <p>卡类型：{{ item.changeCmccSimName }}</p>
        <p>状态：{{ item.disposeState == 1 ? '待发货' : item.disposeState == 2 ? '拒绝' : '已发货'}}</p>
        <p>备注：{{ item.disposeRemark }}</p>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
import { wxRequest } from '@/api/user.js' 
export default {
  data(){
    return {
      takePhone:'',
      disposeState: '',
      oldIccid: this.$store.state.iccid,
      buyCardList: [],
      loading: false,
      finished: true,
      recordLoginText: localStorage.getItem('recordLoginText')
    }
  },
  methods: {
    onLoad(){

    },
    getQuestionList(){
      let data = {
        takePhone: this.takePhone
      }
      wxRequest('applyChangeSim/buy/iccid/lists', data, 'post').then(res => {
        if(res.data.code == 200){
          this.buyCardList = res.data.data.resultList;
        }
      })
    }
  },
  watch:{
      '$route': function(to, from){
          this.disposeState = to.query.disposeState;
          this.getQuestionList();
      }
  },
  created(){
  }
}
</script>

<style>

</style>